
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 18 14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M17.8916 6.46791C16.1963 2.61016 12.8418 0 9 0 5.15819 0 1.80275 2.61188.108406 6.46791.0488125 6.60631 0 6.84503 0 7c0 .15553.0488125.39362.108406.53203C1.80372 11.3898 5.15819 14 9 14c3.8418 0 7.1973-2.6119 8.8916-6.46797C17.9512 7.39362 18 7.15491 18 7c0-.15553-.0488-.39369-.1084-.53209zM9 12.5c-3.10872 0-5.97388-2.1093-7.48675-5.49988C3.03156 3.60516 5.89409 1.5 9 1.5c3.1088 0 5.9739 2.10931 7.4867 5.49981C14.9684 10.3948 12.1059 12.5 9 12.5zM9 3C6.79169 3 5 4.79212 5 7c0 2.20788 1.79169 4 4 4h.00178C11.2092 11 13 9.20875 13 7.00172V7c0-2.20788-1.7916-4-4-4zm0 6.5C7.62153 9.5 6.5 8.37847 6.5 7c0-.02338.00622-.04503.00691-.06825C6.66491 6.97266 6.82875 7 7 7c1.10456 0 2-.89544 2-2 0-.17125-.02734-.33509-.06825-.49309C8.95497 4.50622 8.97663 4.5 9 4.5c1.3785 0 2.5 1.12153 2.5 2.50172C11.5 8.37928 10.3793 9.5 9 9.5z"}})])
          )
        }
      }
    